import { IStudentNote } from './stud-note.model';

export class RegistrationSchoolYearModel {
  studentRegistrationSchoolYearId: number;
  schoolId: number;
  schoolBoardId: number;
  schoolYearId: number;
  schoolName: string;
  previousSchoolId: number;
  outOfTheCountryId: number;
  previousSchoolName: string;
  gradeId: number;
  streamId: number;
  statusId: number;
  designationId: number[];
  accommodation: string;
  addressValidationFileId: string;
  addressValidated: boolean;
  addressValidationContentType: string;
  cohortYear?: string;
  cohortYearId?: number;
  healthInformation?: string;
  notes: IStudentNote[];
}
